import { SET_CURRENT_FILTER } from "../constants/actionTypes";
import deepmerge from "deepmerge";

const initialState = {
  downloads: {
		slug: 'all',
		id: null
	},
  news: {
		slug: 'all',
		id: null
	},
  projects: {
		slug: 'alll',
		id: null
	},
  projects_status: {
		slug: 'all',
		id: null
	}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_FILTER:
      return deepmerge(state, action.payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/currentFilterReducer.js